<template>
  <v-dialog v-model="dialog" :width="qrCodeViewer ? 500 : 1500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="border-btn mr-2 align-center justify-center d-flex"
        width="120"
        height="30"
        v-bind="attrs"
        v-on="on"
      >
        <img src="/static/btn/edit.png" class="mr-1" />
        <span class="border-text ">직접입력</span>
      </v-btn>
    </template>
    <v-card v-if="materialList" class="border-white">
      <v-card-title class="text-h5 justify-center lighten-2 back-556C96">
        <h4 class="color-white">
          신규 입고 등록
        </h4>
      </v-card-title>
      <v-row class="pa-0 ma-0 " v-if="orderInvoiceStatus">
        <div class="ml-5 pt-5 width-150">
          <v-select
            solo
            flat
            dense
            :items="stateList"
            v-model="status"
            class="border-aaaaaa height-41 "
            :menu-props="{ offsetY: true }"
          />
        </div>
        <v-spacer />
      </v-row>
      <v-row class="ma-0 pa-0">
        <h4 class="mt-3 ml-3">
          입고차수 클릭 → 전체 내역 복사 / 부위 클릭 → 부위 내역 복사 / 수량
          클릭 → 개별 내역 복사
        </h4>
      </v-row>
      <v-row class="ma-0 pa-0 ml-3 mb-3 mt-2" v-if="!qrCodeViewer">
        <h3 class="pt-2 pr-2">입고일자</h3>
        <v-dialog ref="dialog" v-model="modal" width="388px">
          <template v-slot:activator="{ on, attrs }">
            <div class="width179-height30 align-center">
              <v-text-field
                v-model="date"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                class="ma-0 pa-0"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>

          <DefaultDatePicker
            @update:date="updateReceivedDate"
            @close:date="modal = false"
          />
        </v-dialog>

        <SearchInput
          ref="searchInput"
          class="ml-4"
          @on-search-input="onSearchInput"
          @on-reset-input="setInitCompleteList"
        />
      </v-row>

      <v-simple-table
        class=" mr-3 ml-3 mt-1"
        v-if="!qrCodeViewer"
        :height="completeList.length > 2 ? 500 : ''"
        fixed-header
      >
        <thead>
          <tr>
            <th
              :rowspan="2"
              class="text-center back-556C96 color-white"
              v-if="!orderInvoiceStatus"
            >
              선택
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa back-556C96 color-white "
            >
              입고차수
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa back-556C96 color-white "
            >
              발주차수
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa  back-556C96 color-white"
            >
              부위
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa  back-556C96 color-white"
            >
              동
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa  back-556C96 color-white"
            >
              층
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa  back-556C96 color-white"
            >
              부재
            </th>
            <th
              :colspan="materailLength"
              class="text-center border-bottom-aaaaaa border-left-aaaaaa back-556C96 color-white"
            >
              규격(단위:TON)
            </th>
            <th
              :rowspan="2"
              class="text-center border-left-aaaaaa back-556C96 color-white"
            >
              잔여수량
            </th>
          </tr>
          <tr>
            <th
              v-for="material in materialList"
              :key="material.rebar_id"
              class="text-center border-left-aaaaaa back-556C96 color-white"
            >
              {{ material.rebar_name }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(list, k) of completeList" :key="k">
          <tr>
            <td
              :rowspan="list.invoiceListInfo.length * 2 + 1"
              class="text-center border-aaaaaa"
            >
              <input type="checkbox" v-model="checkboxList[k]" />
            </td>
            <td
              :rowspan="list.invoiceListInfo.length * 2 + 1"
              class="cursor-pointer border-aaaaaa justify-center align-center text-center"
              @click="listFill(list.invoiceListInfo, k, -1, -1)"
            >
              <div style="max-width: 60px;margin: auto;">
                <span>
                  {{ list.invoiceCode }}
                </span>
              </div>
            </td>
          </tr>
          <tr v-for="i of list.invoiceListInfo.length * 2" :key="i">
            <td
              rowspan="2"
              class="text-center border-aaaaaa cursor-pointer"
              v-if="i % 2 == 1"
              @click="
                listFill(list.invoiceListInfo, k, Math.floor((i - 1) / 2), -1)
              "
            >
              {{ list.invoiceListInfo[Math.floor(i / 2)].orderName }}
            </td>
            <td
              rowspan="2"
              class="text-center border-aaaaaa cursor-pointer "
              v-if="i % 2 == 1"
              @click="
                listFill(list.invoiceListInfo, k, Math.floor((i - 1) / 2), -1)
              "
            >
              <div style="max-width:80px; margin: auto;">
                <span>
                  {{ list.invoiceListInfo[Math.floor(i / 2)].partName }}
                </span>
              </div>
            </td>

            <td rowspan="2" class="text-center border-aaaaaa" v-if="i % 2 == 1">
              {{ list.invoiceListInfo[Math.floor(i / 2)].dong }}
            </td>
            <td rowspan="2" class="text-center border-aaaaaa" v-if="i % 2 == 1">
              {{ list.invoiceListInfo[Math.floor(i / 2)].floor }}
            </td>
            <td rowspan="2" class="text-center border-aaaaaa" v-if="i % 2 == 1">
              {{ list.invoiceListInfo[Math.floor(i / 2)].type }}
            </td>
            <td
              v-if="i % 2 == 1 && list.invoiceListInfo[Math.floor((i - 1) / 2)]"
              v-for="a of list.invoiceListInfo[Math.floor((i - 1) / 2)]
                .regacyInvoiceSumList.length"
              :key="(k + 1) * 1500 + (i + 1) * 102 + a"
              @click="
                listFill(
                  list.invoiceListInfo,
                  k,
                  Math.floor((i - 1) / 2),
                  a - 1,
                )
              "
              class="text-center border-aaaaaa cursor-pointer"
            >
              {{
                list.invoiceListInfo[
                  Math.floor((i - 1) / 2)
                ].regacyInvoiceSumList[a - 1].toFixed(3)
              }}
            </td>
            <td v-if="i % 2 == 1" class="text-center border-aaaaaa">
              {{
                sum(
                  list.invoiceListInfo[Math.floor((i - 1) / 2)]
                    .regacyInvoiceSumList,
                ).toFixed(3)
              }}
            </td>
            <td
              v-if="
                i % 2 == 0 &&
                  list.invoiceListInfo[Math.floor((i - 1) / 2)].tempList
              "
              v-for="a of list.invoiceListInfo[Math.floor((i - 1) / 2)].tempList
                .length"
              :key="(a + 1) * 1100 + i * 152"
              class="text-center border-aaaaaa"
            >
              <input
                v-model="
                  list.invoiceListInfo[Math.floor((i - 1) / 2)].tempList[a - 1]
                "
                type="number"
                class="text-center input-number pa-0 border-aaaaaa"
              />
            </td>
            <td v-if="i % 2 == 0" class="text-center border-aaaaaa">
              {{
                sum(
                  list.invoiceListInfo[Math.floor((i - 1) / 2)].tempList,
                ).toFixed(3)
              }}
            </td>
          </tr>
          <tr></tr>
        </tbody>
      </v-simple-table>
      <div class="text-center mt-4 warning-text">
        <span
          v-if="hasSelectedInvalidQuantityItem && !qrCodeViewer"
          class="zero-quantity-warning text-center mt-4"
        >
          선택한 항목의 수량을 입력해 주세요.
        </span>
      </div>
      <v-card-actions
        class=" align-center justify-center pb-5 pt-5"
        v-if="!qrCodeViewer"
      >
        <v-btn
          color="#3F557D"
          class="color-white "
          @click="completeInsert"
          width="150"
          height="40"
          :disabled="hasSelectedInvalidQuantityItem"
        >
          확인
        </v-btn>
        <v-btn color="#eeeeee" @click="dialog = false" width="150" height="40">
          취소
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompleteApi from "@/api/CompleteService";
import Commonality from "@/mixin/Commonality";
import DefaultDatePicker from "@/components/DefaultDatePicker.vue";
import SearchInput from "@/components/SearchInput.vue";

export default {
  mixins: [Commonality],
  props: ["invoiceId", "orderId", "orderInvoiceStatus"],
  components: {
    DefaultDatePicker,
    SearchInput,
  },
  data: function() {
    return {
      dialog: false,
      insertDate: "",
      materailLength: 0,
      invoiceList: [],
      checkboxList: [],
      choiceState: false,
      tableLength: 0,
      qrCode: "",
      qrCodeViewer: false,
      downCount: 0,
      status: "입고완료",
      stateList: ["입고완료", "발주완료"],
      modal: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      completeList: [],
      kStatus: false,
      initCompleteList: [],
    };
  },
  created: async function() {
    await this.reset();
    if (this.orderInvoiceStatus) this.checkboxList[0] = true;
  },
  watch: {
    async dialog(value) {
      if (value) {
        await this.reset();
        if (this.orderInvoiceStatus) this.checkboxList[0] = true;
      } else {
        this.qrCodeViewer = false;
        this.$refs.searchInput.onResetInput();
      }
    },
  },
  computed: {
    hasSelectedInvalidQuantityItem() {
      return this.completeList.some((list, index) => {
        if (!this.checkboxList[index]) return false;

        const quantitySum = list.invoiceListInfo.reduce(
          (listTotal, info) =>
            listTotal +
            info.tempList.reduce(
              (quantityTotal, value) => quantityTotal + Number(value || 0),
              0,
            ),
          0,
        );

        return quantitySum <= 0;
      });
    },
  },
  methods: {
    /** 검색인풋 이벤트핸들러 */
    onSearchInput({ type, value }) {
      if (!value?.trim() || value.length === 0) {
        return this.setInitCompleteList();
      }
      const fieldList = {
        발주차수: "orderName",
        부위: "partName",
      };
      const fieldName = fieldList[type];
      const inputVal = value.replaceAll(" ", "");

      const filtered = this.initCompleteList.filter((el) => {
        // 1. 배열인 경우
        if (el.invoiceListInfo.length > 1) {
          const 차수 = el.invoiceListInfo.some(
            (info) => info[fieldName] === inputVal,
          );
          const 부위 = el.invoiceListInfo.some((info) =>
            info[fieldName].includes(inputVal),
          );
          return fieldName === "partName" ? 부위 : 차수;
        }

        // 2. 요소가 1개인 경우
        const itemVal = el.invoiceListInfo[0][fieldName].replaceAll(" ", "");
        if (fieldName === "partName") {
          return itemVal.includes(inputVal);
        }
        return itemVal === inputVal;
      });
      this.completeList = filtered;
    },
    /** 초기값으로 세팅 */
    setInitCompleteList() {
      this.completeList = this.initCompleteList;
    },
    updateReceivedDate(date) {
      this.date = date;
      this.modal = false;
    },
    focusClear(val, index, i) {
      if (val != 0) return;
      let list = [];
      for (let j = 0; j < this.completeList[index].tempList.length; j++) {
        if (i - 1 != j)
          list.push(this.mathRound(this.completeList[index].tempList[j]));
        else list.push("");
      }
      this.completeList[index].tempList = list;
    },

    listFill(list, row1, row, col) {
      if (row >= 0 && col >= 0) {
        list[row].tempList[col] = list[row].regacyInvoiceSumList[col];
      } else if (row >= 0) {
        list[row].tempList = list[row].regacyInvoiceSumList.map((a) => a);
      } else {
        for (let i of list) {
          i.tempList = i.regacyInvoiceSumList.map((a) => a);
        }
      }
      this.checkboxList[row1] = true;
      this.checkboxList = this.checkboxList.map((a) => a);
    },

    confirmOk() {
      this.dialog = !this.dialog;
      this.qrCodeViewer = !this.qrCodeViewer;
    },
    async reset() {
      let data = {
        constructionId: this.constructionId,
      };
      let res = await CompleteApi.completeInvoiceList(data);
      const invoiceList = res.data.invoiceList;
      this.materailLength = this.materialList.length;
      for (let i = 0; i < invoiceList.length; i++) {
        let info = invoiceList[i].invoiceListInfo;
        for (let j = 0; j < info.length; j++) {
          info[j].tempSum = 0;
          info[j].tempList = [];
          for (let k = 0; k < this.materailLength; k++) {
            info[j].tempList[k] = 0;
          }
        }
      }
      this.completeList = invoiceList;
      this.initCompleteList = invoiceList;
      this.tableLength = this.completeList.length;
      this.choiceState = false;
      this.checkboxList = [];
      this.downCount = 0;
      this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    },

    async completeInsert() {
      let resultData = this.checkboxList.filter(
        (checkboxValue) => checkboxValue == true,
      );
      if (resultData.length == 0) {
        this.$bus.$emit("dialog", "선택 후 업로드를 진행 해주세요.");
        return;
      }

      let dataList = [];
      for (let i = 0; i < this.checkboxList.length; i++) {
        if (this.checkboxList[i]) {
          for (let k of this.completeList[i].invoiceListInfo) {
            let tempList = [];
            for (let j = 0; j < this.materialList.length; j++) {
              tempList.push({
                rebarName: this.materialList[j].rebar_name,
                rebarValue: k.tempList[j],
              });
              //tempList.push( {rebarValue: this.rebarList[i], rebarName: this.materialList[i].rebar_name} )
            }
            dataList.push({
              invoiceId: this.completeList[i].invoiceId,
              constructionId: this.constructionId,
              selectDate: this.date,
              rebarListData: tempList,
              orderId: k.orderId,
            });
          }
        }
      }
      try {
        let text = "";
        for await (let i of dataList) {
          const res = await CompleteApi.completeCreate(i);
          if (res.data.success === "ok") {
            text = "입고 처리가 완료했습니다.";
          } else {
            const msg = res.data.message
              ? res.data.message
              : "입고 처리에 실패하였습니다. \n 잠시 후 시도해주세요.";
            text = msg;
          }
        }
        this.$bus.$emit("dialog", text);
        // this.$bus.$emit("dialog", "입고 처리가 완료했습니다.");
      } catch (error) {
        console.log(error);
        this.$bus.$emit(
          "dialog",
          "입고 처리에 실패하였습니다. \n 잠시 후 시도해주세요.",
        );
      }

      this.$emit("resetMethod");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.width-150 {
  width: 150px;
}

.height-41 {
  height: 41px;
}

.pb-8 {
  padding-bottom: 8px;
}

.input-number {
  width: 60px;
}

.zero-quantity-warning {
  color: #d32f2f;
  font-size: 14px;
  font-weight: 500;
}
.warning-text {
  height: 14px;
}
</style>
